import { optionField, stringField } from '@/common/utils/form/fieldTypes';

export const purchasing_requisitions_highlight_most_expensive =
  'purchasing_requisitions_highlight_most_expensive';
export const purchasing_requisitions_highlight_cheapest =
  'purchasing_requisitions_highlight_cheapest';
export const purchasing_requisition_code = 'purchasing_requisition_code';
export const purchasing_pdf_show_company_notes = 'purchasing_pdf_show_company_notes';
export const purchasing_pdf_show_invoices_should_be_sent_to =
  'purchasing_pdf_show_invoices_should_be_sent_to';
export const purchasing_pdf_show_invoices_should_be_issued_to =
  'purchasing_pdf_show_invoices_should_be_issued_to';
export const purchasing_requisition_prefill_po_company =
  'purchasing_requisition_prefill_po_company';

export type PurchasingRequisitionHighlightMostExpensive =
  | {
      label: string;
      value: string;
    }
  | number
  | null;

export type PurchasingRequisitionHighlightCheapest =
  | { label: string; value: string }
  | number
  | null;

export type PurchasingRequisitionBooleanOption = { label: string; value: string } | null;

export type PurchasingRequisitionCode = string | null;

export type PurchasingType = {
  [purchasing_requisitions_highlight_most_expensive]: PurchasingRequisitionHighlightMostExpensive;
  [purchasing_requisitions_highlight_cheapest]: PurchasingRequisitionHighlightCheapest;
  [purchasing_requisition_code]: PurchasingRequisitionCode;
  [purchasing_pdf_show_company_notes]: PurchasingRequisitionBooleanOption;
  [purchasing_pdf_show_invoices_should_be_sent_to]: PurchasingRequisitionBooleanOption;
  [purchasing_pdf_show_invoices_should_be_issued_to]: PurchasingRequisitionBooleanOption;
  [purchasing_requisition_prefill_po_company]: PurchasingRequisitionBooleanOption;
};

const config = {
  [purchasing_requisitions_highlight_most_expensive]: optionField(),
  [purchasing_requisitions_highlight_cheapest]: optionField(),
  [purchasing_requisition_code]: stringField(),
  [purchasing_pdf_show_company_notes]: optionField(),
  [purchasing_pdf_show_invoices_should_be_sent_to]: optionField(),
  [purchasing_pdf_show_invoices_should_be_issued_to]: optionField(),
  [purchasing_requisition_prefill_po_company]: optionField()
};

export default config;
